import React, { Suspense } from 'react';
import { Navigate } from 'react-router-dom';

import LoadingSpinner from '@components/loading-spinner/LoadingSpinner';
import LazyLoadable from '@helpers/LazyLoadable';
import { lazy } from '@loadable/component';
import { ARCHEM_APPS } from '@src/app/pages/home/ArchemApps';
import ProtectedRoute from '@src/app/routes/ProtectedRoute';

const JobTitlesDialog = LazyLoadable(lazy(() => import('./users/job-titles/JobTitlesDialog')));
const UserAddEditDialog = LazyLoadable(lazy(() => import('./users/UserAddEditDialog')));
const UsersCard = LazyLoadable(lazy(() => import("./users/UsersCard")))

export const ROUTES_USER_MAINTENANCE = [
  {
    path: "/archemusers",
    element: <Suspense fallback={<LoadingSpinner />}> <ProtectedRoute module_name={ARCHEM_APPS.USER_MAINTENANCE.module_name} /></Suspense>,
    children: [
      {
        index: true,
        element: <Navigate to="list" />,
      },
      {
        path: 'list/*',
        element: <UsersCard />,
        children: [
          {
            path: 'new',
            element: <UserAddEditDialog />
          },
          {
            path: 'jobtitle',
            element: <JobTitlesDialog />
          },
          {
            path: ':id',
            element: <UserAddEditDialog />
          }
        ],
        meta: {
          abilities: [
            { action: 'user_maintenance', resource: 'User Maintenance' }
          ]
        }
      }
    ]

  },


];
